var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmQuestionmark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.012,
    height: 13.012,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6764"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "question (1)",
    d: "M6.506 0a6.506 6.506 0 106.506 6.506A6.513 6.513 0 006.506 0zm0 10.3a.542.542 0 11.542-.542.542.542 0 01-.542.542zm.858-3.447a.545.545 0 00-.316.493v.244a.542.542 0 01-1.084 0v-.243a1.633 1.633 0 01.946-1.478 1.772 1.772 0 00.951-1.261 1.355 1.355 0 00-2.711 0 .542.542 0 11-1.084 0 2.44 2.44 0 114.88 0 2.825 2.825 0 01-1.582 2.246zm0 0",
    opacity: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmQuestionmark);
export default __webpack_public_path__ + "static/media/am-questionmark.dfcd0e98031e723d33834358abc76cc4.svg";
export { ForwardRef as ReactComponent };